import { render } from "./moneyDetail.vue?vue&type=template&id=257c51d0&scoped=true"
import script from "./moneyDetail.vue?vue&type=script&lang=js"
export * from "./moneyDetail.vue?vue&type=script&lang=js"

import "./moneyDetail.vue?vue&type=style&index=0&id=257c51d0&lang=less&scoped=true"

import exportComponent from "/root/workspace/service-web_SY5C/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257c51d0"]])

export default __exports__